import memberJson from '../data/catalog.member.json';
import type { MemberLayer } from './types';

/**
 * Member/public catalog accessor (OQ6 hardening). The member catalog surface
 * and the Control Room shop-window import THIS module — never `./catalog`.
 * `catalog.member.json` carries only the member layer (promoted helpers, the
 * Foundation chains, the changelog feed); the internal cockpit data (evals,
 * experiment ledger, writeback diffs, source paths) lives in `catalog.json`,
 * which must not be imported from any publicly-served surface.
 */
const data = memberJson as unknown as {
  generatedAt: string;
  mode: 'internal' | 'product';
  member: MemberLayer;
};

export const member: MemberLayer = data.member;
export const generatedAt = data.generatedAt;
